module.exports = __webpack_public_path__ + "static/img/hover_btn_app.43fcadb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hover_btn_app.png
// module id = 98VY
// module chunks = 1